import { JSX }	from "preact";

import { Simplify }	from "ts-base/type";
import { Dom }		from "ts-base/web/dom";

import { FaIcon }	from "@v3/geko/faIcon";

export type DecorProps =
	Simplify<DecorBase & DecorContent>;

export type DecorBase	= Readonly<{
	style:	DecorStyle,
	// defaults to "normal"
	size?:	DecorSize,
	label:	DecorLabel,
	hint?:	string,
}>;

export type DecorStyle	= "text"|"link"|"primary"|"secondary"|"circle"|"hoverinvert";
export type DecorSize	= "normal"|"small";
// TODO decor do we want ComponentChildren here?
export type DecorLabel	= string;

export type DecorContent = Simplify<DecorWithIcon | DecorWithoutIcon>;

export type DecorWithIcon	=
	Readonly<{
		icon:	FaIcon,
		layout:	"always-icon"|"always-both"|"keep-label"|"keep-icon"|"switch",
	}>;

export type DecorWithoutIcon	=
	Readonly<{
		layout:	"always-label",
	}>;

const isDecorWithIcon	= (it:DecorContent):it is DecorWithIcon	=>
	it.layout !== "always-label";

export const Decor = (props:DecorProps):JSX.Element =>
	<span
		class={Dom.classes(
			"Decor",
			`Decor--style-${props.style}`,
			`Decor--size-${props.size ?? "normal"}`,
			`Decor--layout-${props.layout}`,
			[ "always-both", "keep-label", "keep-icon", "switch" ].includes(props.layout) && "Decor--content-both",
		)}
		title={title(props.label, props.hint)}
	>
		{ isDecorWithIcon(props) &&
			<span class={Dom.classes(
				"Decor-icon",
				"fa",
				props.icon,
			)}/>
		}
		<span class="Decor-label">
			{props.label}
		</span>
		{ props.hint !== undefined &&
			<span class="Decor-hint">
				{props.hint}
			</span>
		}
	</span>;

const title	= (label:DecorLabel, hint:string|undefined)	=>
	[ label.toString(), hint ?? "" ].filter(it => it !== "").join("\n\n");
